import React from 'react';
import MoneyInput from './MoneyInput';
import ButtonChoice from './ButtonChoice';
import TextInput from './TextInput';
let Questions = require('../Managers/Questions');

const ChildQuestion = React.createClass({
    propTypes: {
        show: React.PropTypes.bool,
        question: React.PropTypes.string,
        fieldName : React.PropTypes.string,
        type : React.PropTypes.string,
        helpText : React.PropTypes.string,
        questionId : React.PropTypes.number,
        display_dependencies : React.PropTypes.array,
        options : React.PropTypes.array,
        supplementaryId : React.PropTypes.string,
        supplementaryText : React.PropTypes.string,
        noBorder: React.PropTypes.string,
    },
    primaryChild : {},
    getPrimaryChild() {
        return this.primaryChild;
    },

    render() {
        let self = this;
        return (
            <div ref={this.props.fieldName+'_'+Questions.guid()}>
                {this.props.show ?
                    <div className="child-question-row">
                        {this.props.type === 'money' ?
                            <MoneyInput
                                question={this.props.question}
                                fieldName={this.props.fieldName}
                                supplementaryId={this.props.supplementaryId}
                                supplementaryText={this.props.supplementaryText}
                                helpText={this.props.helpText}
                                noBorder={this.props.noBorder}
                                inputMask="9999999"
                                ref={function(component) { self.primaryChild = component; }}
                            />
                        :null}
                        {this.props.type === 'radio' ?
                            <ButtonChoice
                                question={this.props.question}
                                helpText={this.props.helpText}
                                questionId={this.props.questionId}
                                fieldName={this.props.fieldName}
                                supplementaryId={this.props.supplementaryId}
                                supplementaryText={this.props.supplementaryText}
                                loadCachedValue={false}
                                options={this.props.options}
                                children={this.props.display_dependencies}
                                noBorder={this.props.noBorder}
                                ref={function(component) { self.primaryChild = component; }}
                            />
                        :null}
                        {this.props.type === 'boolean' ?
                            <ButtonChoice
                                question={this.props.question}
                                helpText={this.props.helpText}
                                questionId={this.props.questionId}
                                fieldName={this.props.fieldName}
                                supplementaryId={this.props.supplementaryId}
                                supplementaryText={this.props.supplementaryText}
                                loadCachedValue={false}
                                children={this.props.display_dependencies}
                                noBorder={this.props.noBorder}
                                ref={function(component) { self.primaryChild = component; }}
                                options={[
                                    {
                                        option_text: 'Yes',
                                        option_value: 'yes'
                                    },
                                    {
                                        option_text: 'No',
                                        option_value: 'no'
                                    }
                                ]}
                            />
                        :null}
                        {this.props.type === 'string' ?
                            <TextInput
                                question={this.props.question}
                                helpText={this.props.helpText}
                                fieldName={this.props.fieldName}
                                supplementaryId={this.props.supplementaryId}
                                supplementaryText={this.props.supplementaryText}
                                loadCachedValue={true}
                                maxLength={50}
                                noBorder={this.props.noBorder}
                                ref={function(component) { self.primaryChild = component; }}
                            />
                        :null}
                    </div>
                :null}
            </div>
        );
    },
});

export default ChildQuestion;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/ChildQuestion.js
 **/